import UrlParser from "@/module/Utils/UrlParser";
import {
  formatDateOrNull,
  formatDateTimeOrNull,
} from "@/module/Utils/DateTimeHelpers";
import FormData from "@/module/FormData";

export default class StatisticsReporter {
  private readonly baseUrl: string;

  private readonly path: string;

  constructor(baseUrl: string, path: string) {
    this.baseUrl = baseUrl;
    this.path = path;
  }

  public incrementVisits(): void {
    try {
      if (
        UrlParser.getInstance().isWebFapiPreview() ||
        typeof localStorage === "undefined"
      ) {
        return;
      }

      localStorage.getItem("fapi-test-local-storage-availability");
    } catch (exception) {
      console.error(exception);

      return;
    }

    const currentDateTime = new Date(Date.now());
    const formLastVisitKey = "formLastVisit_" + this.path;
    const formLastVisitItem = localStorage.getItem(formLastVisitKey);

    if (formLastVisitItem === null) {
      localStorage.setItem(formLastVisitKey, currentDateTime.toISOString());

      this.sendIncrementVisitsRequest(currentDateTime).catch((e) => {
        console.warn(e);
      });

      return;
    }

    const formLastVisitDateTime = new Date(
      Date.parse(localStorage.getItem(formLastVisitKey) ?? "") + 1800000,
    );

    if (formLastVisitDateTime > currentDateTime) {
      return;
    }

    localStorage.setItem(formLastVisitKey, currentDateTime.toISOString());
    this.sendIncrementVisitsRequest(currentDateTime).catch((e) => {
      console.warn(e);
    });
  }

  sendIncrementVisitsRequest(date: Date): Promise<Response> {
    return fetch(
      this.baseUrl +
        "/increment-visit?path=" +
        this.path +
        "&date=" +
        formatDateOrNull(date),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "omit",
      },
    );
  }

  async incrementOrderIntent(formData: FormData): Promise<Response | void> {
    if (UrlParser.getInstance().isWebFapiPreview()) {
      return;
    }

    const date = new Date(Date.now());

    return fetch(
      this.baseUrl +
        "/increment-order-intent?path=" +
        this.path +
        "&date=" +
        formatDateOrNull(date),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          form_fill_duration: formData.form_fill_duration,
          form_first_interaction: formatDateTimeOrNull(
            formData.form_first_interaction,
          ),
          form_loaded: formatDateTimeOrNull(formData.form_loaded),
        }),
        credentials: "omit",
      },
    );
  }

  async incrementConversion(formData: FormData): Promise<Response | void> {
    if (UrlParser.getInstance().isWebFapiPreview()) {
      return;
    }

    const date = new Date(Date.now());

    return fetch(
      this.baseUrl +
        "/increment-conversion?path=" +
        this.path +
        "&date=" +
        formatDateOrNull(date),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          form_fill_duration: formData.form_fill_duration,
          form_first_interaction: formatDateTimeOrNull(
            formData.form_first_interaction,
          ),
          form_loaded: formatDateTimeOrNull(formData.form_loaded),
        }),
        credentials: "omit",
      },
    );
  }
}
